import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiCode} from 'react-icons/fi';
import useLocale from '../../hooks/useLocale';
import {
  AboutContainer,
  AboutContent,
  AboutHero,
  AboutImage,
  AboutText,
  AboutTitle,
  AboutDescription,
  AboutHighlight,

  JourneySection,
  JourneyTitle,
  JourneySteps,
  JourneyStep,
  StepNumber,
  StepContent,
  StepTitle,
  StepDescription
} from './About.styles';


const About = () => {
  const { t } = useLocale();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
      duration: 0.5,
      staggerChildren: 0.08
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
      duration: 0.45,
        ease: "easeOut"
      }
    }
  };


  const journeySteps = t('about.journeySteps') || [];

  return (
    <AboutContainer id="about" className="section section--white">
      <AboutContent className="container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <AboutHero>
            <AboutImage
              as={motion.div}
              variants={itemVariants}
            >
              <div className="image-container">
                <img 
                  src="/images/karim-profile.jpg" 
                  alt="Karim Menem"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="fallback-placeholder">
                  <FiCode size={80} />
                  <span>Karim Menem</span>
                </div>
              </div>
            </AboutImage>

            <AboutText>
              <motion.div variants={itemVariants}>
                <AboutTitle>{t('about.title')}</AboutTitle>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <AboutDescription>
                  <p>
                    {t('about.paragraph1.before')}
                    <AboutHighlight>{t('about.paragraph1.highlight1')}</AboutHighlight>
                    {t('about.paragraph1.middle')}
                    <AboutHighlight>{t('about.paragraph1.highlight2')}</AboutHighlight>
                    {t('about.paragraph1.after')}
                  </p>
                  <p>
                    {t('about.paragraph2.before')}
                    <AboutHighlight>{t('about.paragraph2.highlight1')}</AboutHighlight>
                    {t('about.paragraph2.middle')}
                  </p>
                  <p>
                    {t('about.paragraph3.before')}
                    <AboutHighlight>{t('about.paragraph3.highlight1')}</AboutHighlight>
                    {t('about.paragraph3.middle')}
                  </p>
                </AboutDescription>
              </motion.div>
            </AboutText>
          </AboutHero>

          {/* <motion.div variants={itemVariants}>
            <MetricsGrid>
              {metrics.map((metric, index) => (
                <MetricCard
                  key={index}
                  as={motion.div}
                  whileHover={{ y: -8, scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                >
                  <metric.icon size={32} />
                  <MetricNumber>{metric.number}</MetricNumber>
                  <MetricLabel>{metric.label}</MetricLabel>
                </MetricCard>
              ))}
            </MetricsGrid>
          </motion.div> */}

          {/* <ValuesSection>
            <motion.div variants={itemVariants}>
              <h3>What Drives Me</h3>
            </motion.div>
            <motion.div variants={itemVariants}>
              <div>
                {values.map((value, index) => (
                  <ValueItem
                    key={index}
                    as={motion.div}
                    whileHover={{ x: 10 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ValueIcon>
                      <value.icon />
                    </ValueIcon>
                    <ValueText>{value.text}</ValueText>
                  </ValueItem>
                ))}
              </div>
            </motion.div>
          </ValuesSection> */}

          <JourneySection>
            <motion.div variants={itemVariants}>
              <JourneyTitle>{t('about.journeyTitle')}</JourneyTitle>
            </motion.div>
            <JourneySteps>
              {journeySteps.map((step, index) => (
                <motion.div key={index} variants={itemVariants}>
                  <JourneyStep
                    as={motion.div}
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                  >
                    <StepNumber>{index + 1}</StepNumber>
                    <StepContent>
                      <StepTitle>{step.title}</StepTitle>
                      <StepDescription>{step.description}</StepDescription>
                    </StepContent>
                  </JourneyStep>
                </motion.div>
              ))}
            </JourneySteps>
          </JourneySection>
        </motion.div>
      </AboutContent>
    </AboutContainer>
  );
};

export default About;